import { render } from "./RetrievePassword.vue?vue&type=template&id=2ca0e2e8&scoped=true"
import script from "./RetrievePassword.vue?vue&type=script&lang=js"
export * from "./RetrievePassword.vue?vue&type=script&lang=js"

import "./RetrievePassword.vue?vue&type=style&index=0&id=2ca0e2e8&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ca0e2e8"]])

export default __exports__